// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IExchangeTokenRequestDto
 */
export interface IExchangeTokenRequestDto {
    /**
     * 
     * @type {string}
     * @memberof IExchangeTokenRequestDto
     */
    public_token: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof IExchangeTokenRequestDto
     */
    plaid_account_ids: Array<string>;
}

/**
 * Check if a given object implements the IExchangeTokenRequestDto interface.
 */
export function instanceOfIExchangeTokenRequestDto(value: object): value is IExchangeTokenRequestDto {
    if (!('public_token' in value) || value['public_token'] === undefined) return false;
    if (!('plaid_account_ids' in value) || value['plaid_account_ids'] === undefined) return false;
    return true;
}

export function IExchangeTokenRequestDtoFromJSON(json: any): IExchangeTokenRequestDto {
    return IExchangeTokenRequestDtoFromJSONTyped(json, false);
}

export function IExchangeTokenRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IExchangeTokenRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'public_token': json['public_token'],
        'plaid_account_ids': json['plaid_account_ids'],
    };
}

export function IExchangeTokenRequestDtoToJSON(json: any): IExchangeTokenRequestDto {
    return IExchangeTokenRequestDtoToJSONTyped(json, false);
}

export function IExchangeTokenRequestDtoToJSONTyped(value?: IExchangeTokenRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'public_token': value['public_token'],
        'plaid_account_ids': value['plaid_account_ids'],
    };
}

